"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../util/GlobalScript.js");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FormLabel = _interopRequireDefault(require("./FormLabel"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
* @class SelectionFilterLabel
* @desc Displays a label with the appearance of a select input, showing a count of the number of filters selected
*
* @param {string} [data-id="selection-filter"]
*     The "data-id" attribute for top-level HTML container.
* @param {string} [className]
*     Additional CSS classes that are added to the top-level HTML container
* @param {number} [count]
*     The number that is displayed to the right of the filterLabel
* @param {node} [description]
*     Description to display below the label.
* @param {string} [filterLabel]
*     The text to display inside of the SelectionFilterLabel
* @param {string} [labelText]
*     The text to display as an input label above the SelectionFilterLabel
* @param {string} [label]
*     Alias for labelText
* @param {boolean} [open]
*     Is this view opened?
* @param {string} [placeholder]
*     Text that displays as a placeholder if filterLabel is empty
* @param {bool} [required=false]
*     When true the required styling is applied to the component
* @param {object} [style]
*     A react-style style object used to inject hard-coded styles into the parent label container.
*     *** Note that this prop should be used sparingly and only with the consent of the UX dev team. ***
*
* @example
*     <SelectionFilterLabel
*         data-id="filter-data-id"
*         filterLabel="Selected Filters"
*         labelText="My Label"
*         count={count}
*         className="custom-css-class"
*     />
*
*/
var SelectionFilterLabel = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(SelectionFilterLabel, _React$Component);

  var _super = _createSuper(SelectionFilterLabel);

  function SelectionFilterLabel() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, SelectionFilterLabel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_renderSelectionFilter", function () {
      var classNames = {
        required: _this.props.required,
        "selection-filter-label--open": _this.props.open
      };
      return /*#__PURE__*/_react.default.createElement("div", {
        "data-id": _this.props["data-id"],
        className: (0, _classnames.default)("selection-filter-label", _this.props.className, classNames),
        style: _this.props.style
      }, _this.props.filterLabel !== "" ? _this.props.filterLabel : /*#__PURE__*/_react.default.createElement("span", {
        className: "selection-filter-label__placeholder"
      }, _this.props.placeholder), _this.props.count >= 0 && /*#__PURE__*/_react.default.createElement("span", {
        "data-id": _this.props["data-id"] + "-count",
        className: "count"
      }, _this.props.count));
    });
    return _this;
  }

  (0, _createClass2.default)(SelectionFilterLabel, [{
    key: "render",
    value: function render() {
      var labelText = this.props.labelText || this.props.label;
      return labelText ? /*#__PURE__*/_react.default.createElement(_FormLabel.default, {
        "data-id": this.props["data-id"] + "-label",
        value: labelText,
        description: this.props.description
      }, this._renderSelectionFilter()) : this._renderSelectionFilter();
    }
  }]);
  return SelectionFilterLabel;
}(_react.default.Component);

(0, _defineProperty2.default)(SelectionFilterLabel, "propTypes", {
  "data-id": _propTypes.default.string,
  className: _propTypes.default.string,
  count: _propTypes.default.number,
  description: _propTypes.default.node,
  filterLabel: _propTypes.default.string.isRequired,
  labelText: _propTypes.default.string,
  label: _propTypes.default.string,
  open: _propTypes.default.bool,
  required: _propTypes.default.bool,
  style: _propTypes.default.object
});
(0, _defineProperty2.default)(SelectionFilterLabel, "defaultProps", {
  "data-id": "selection-filter",
  open: false
});
module.exports = SelectionFilterLabel;